module.exports = __webpack_public_path__ + "img/shipment.ce41e310.svg";